var exports = {
  "kL": "x127c5a35--a826c0--container",
  "DD": "x127c5a35--a826c0--title",
};

module.exports = exports;
